export default Object.freeze({
  MentoringMipe: {
    directoryName: 'subscriptions/mentoringmipe',
    fileName: 'RPT_REG_InformeMonitoria_MIPE.xlsx',
  },
  Query2: {
    directoryName: 'subscriptions/query2',
    fileName: 'RPT_ReferidosQuery2.xlsx',
  },
  RegistrationSignatures: {
    directoryName: 'subscriptions/firmasregistro',
    fileName: 'RPT_FirmasRegistro-{0}.xlsx',
  },
});
